import React from 'react';
import './AddColorMulti.scss';
import LabelSelectBox from "../LabelSelectBox/LabelSelectBox";
import TitleWithLine from "../TitleWithLine/TitleWithline"
import TwoColumnTable from "../TwoColumnTable/TwoColumnTable";

const AddColorMulti = ({ProducData, sendData, setSendData}) => {

  const boxHandler = (e, v) => {

    let addedToTable = false;
    const label = v.label;
    const value = v.value;
    const uniqId = (Math.random() * 1000000000);
    const temp = [...sendData?.rang];

    temp.forEach(v => {
      if (v.value === value) {
        addedToTable = true;
      }
    })

    if (!addedToTable) {
      temp.push({uniqId, label, value})
      setSendData({...sendData, rang: temp})
    }
  }

  const ItemDataHandler = (v) => {
    setSendData({...sendData, rang: v})
  }

  try {
    return (
      <div className="main-color-multi">
        <TitleWithLine title="تعریف رنگ" LineClass="line-solid"/>

        <LabelSelectBox
          labelText={"رنگ"}
          defaultValue={""}
          options={ProducData?.rang}
          onSelect={boxHandler}
          emptyInputAfterSubmit={true}
        />

        <TwoColumnTable
          title="نام رنگ"
          TabelData={sendData?.rang}
          TalelItemData={ItemDataHandler}
        />
      </div>
    )
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default AddColorMulti;